import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router'
import { useUserContext } from '@/context/userLogin'
import { AuthCard } from '@/components/auth/auth-card'

export default function AuthPage() {
  const navigate = useNavigate()
  const { user, firstLogin } = useUserContext()

  useEffect(() => {
    if (user) navigate(firstLogin ? '/company-setup' : '/')
  }, [user, firstLogin, navigate])

  return (
    <main className="flex h-screen overflow-hidden">
      <div className="flex w-full flex-col px-4 py-8 lg:px-16 lg:py-12">
        <div className="mx-auto flex max-w-md flex-1 flex-col justify-center space-y-4">
          <div className="">
            <h2 className="drop-shadow-xs text-3xl font-bold leading-tight sm:text-5xl">
              Create social posts
            </h2>
            <h2 className="bg-linear-to-r mt-2 inline-block from-[#ff6b6b] via-[#feca57] to-[#5ffbf1] bg-clip-text text-3xl font-bold leading-tight text-transparent sm:text-5xl">
              in seconds
            </h2>
            <p className="text-muted-foreground text-md sm:text-lg">
              Keep it personal. Keep it on-brand. That's the magic of CASSI.
            </p>
          </div>

          {/* Auth card */}
          <AuthCard />

          {/* Legal links */}
          <p className="text-muted-foreground text-center text-xs">
            By signing in, you agree to our{' '}
            <Link to="/terms-of-service" className="text-primary hover:underline">
              Terms of Service
            </Link>{' '}
            and{' '}
            <Link to="/privacy" className="text-primary hover:underline">
              Privacy Policy
            </Link>
          </p>
        </div>
      </div>
    </main>
  )
}
